var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQueryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.977,
    height: 50,
    viewBox: "0 0 49.977 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(-202 -101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M24.84,34.8v0Z",
    transform: "translate(206.03 106.645)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M24.8,34.77h0Z",
    transform: "translate(206.024 106.641)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M24.792,34.733a.036.036,0,0,0-.012-.023.036.036,0,0,0,.012.023",
    transform: "translate(206.021 106.632)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M24.762,34.683a.036.036,0,0,0-.012-.023.036.036,0,0,0,.012.023",
    transform: "translate(206.016 106.624)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M24.74,34.643v0Z",
    transform: "translate(206.014 106.617)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M24.71,34.6v0Z",
    transform: "translate(206.009 106.611)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M24.69,34.553v0Z",
    transform: "translate(206.006 106.602)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M24.68,34.513v0Z",
    transform: "translate(206.004 106.596)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M24.66,34.463v0Z",
    transform: "translate(206.001 106.588)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M24.64,34.423v0Z",
    transform: "translate(205.998 106.581)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M24.63,34.373v0Z",
    transform: "translate(205.996 106.573)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M24.62,34.323v0Z",
    transform: "translate(205.995 106.565)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M24.62,34.273v0Z",
    transform: "translate(205.995 106.557)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M24.61,34.233v0Z",
    transform: "translate(205.993 106.551)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M24.925,33.42s-.035.035-.035.046c0-.012.023-.035.035-.046",
    transform: "translate(206.038 106.422)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M24.873,33.47s-.023.023-.023.035a.167.167,0,0,1,.023-.035",
    transform: "translate(206.032 106.431)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M24.833,33.51a.167.167,0,0,1-.023.035.041.041,0,0,1,.023-.035",
    transform: "translate(206.025 106.437)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M24.8,33.56s-.012.023-.023.023Z",
    transform: "translate(206.021 106.445)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M24.772,33.6s0,.023-.012.023a.036.036,0,0,1,.012-.023",
    transform: "translate(206.017 106.452)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M24.752,33.64s0,.023-.012.023a.036.036,0,0,1,.012-.023",
    transform: "translate(206.014 106.458)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M24.722,33.69s0,.023-.012.023a.036.036,0,0,1,.012-.023",
    transform: "translate(206.009 106.466)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M24.7,33.73v0Z",
    transform: "translate(206.008 106.473)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M24.68,33.78v0Z",
    transform: "translate(206.004 106.481)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M24.67,33.82v0Z",
    transform: "translate(206.003 106.487)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M24.65,33.87v0Z",
    transform: "translate(206 106.495)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M24.64,33.91v0Z",
    transform: "translate(205.998 106.502)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M24.63,33.96v0Z",
    transform: "translate(205.996 106.51)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M24.62,34.01v0Z",
    transform: "translate(205.995 106.518)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M25.13,33.215l.035-.035s-.023.035-.035.035",
    transform: "translate(206.077 106.383)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M25.18,33.163a.167.167,0,0,0,.035-.023s-.023.023-.035.023",
    transform: "translate(206.085 106.377)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M25.22,33.133a.167.167,0,0,0,.035-.023c-.012,0-.023,0-.035.023",
    transform: "translate(206.092 106.372)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M25.26,33.1a.167.167,0,0,0,.035-.023.167.167,0,0,0-.035.023",
    transform: "translate(206.098 106.367)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M25.3,33.083a.167.167,0,0,0,.035-.023.041.041,0,0,0-.035.023",
    transform: "translate(206.105 106.364)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M25.34,33.053a.166.166,0,0,0,.046-.023.166.166,0,0,0-.046.023",
    transform: "translate(206.111 106.359)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M25.39,33.022a.057.057,0,0,0,.035-.012.057.057,0,0,0-.035.012",
    transform: "translate(206.12 106.356)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M25.44,33h0Z",
    transform: "translate(206.128 106.354)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M25.49,32.98h0Z",
    transform: "translate(206.136 106.351)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M25.53,32.97h0Z",
    transform: "translate(206.142 106.349)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M25.57,32.95h0Z",
    transform: "translate(206.149 106.346)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M25.62,32.94h0Z",
    transform: "translate(206.157 106.345)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M25.69,32.93h0Z",
    transform: "translate(206.168 106.343)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M25.73,32.92h0Z",
    transform: "translate(206.175 106.341)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M26.35,33.04",
    transform: "translate(206.275 106.361)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M26.03,32.93h0Z",
    transform: "translate(206.223 106.343)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M26.07,32.94h0Z",
    transform: "translate(206.23 106.345)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M26.27,33",
    transform: "translate(206.262 106.354)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M26.31,33.02",
    transform: "translate(206.269 106.357)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    d: "M3.85-1.5H36.782a5.356,5.356,0,0,1,5.35,5.35V36.782a5.356,5.356,0,0,1-5.35,5.35H3.85a5.356,5.356,0,0,1-5.35-5.35V3.85A5.356,5.356,0,0,1,3.85-1.5ZM36.782,39.132a2.353,2.353,0,0,0,2.35-2.35V3.85a2.353,2.353,0,0,0-2.35-2.35H3.85A2.353,2.353,0,0,0,1.5,3.85V36.782a2.353,2.353,0,0,0,2.35,2.35Z",
    transform: "translate(206.684 105.684)",
    fill: "#1a286d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_1",
    "data-name": "Line 1",
    d: "M1.5,40.632h-3V0h3Z",
    transform: "translate(227 105.684)",
    fill: "#0f2a75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M1.825,17.93h5.73a1.825,1.825,0,0,1,1.825,1.825v5.73a1.825,1.825,0,0,1-1.825,1.825H1.825A1.825,1.825,0,0,1,0,25.485v-5.73A1.825,1.825,0,0,1,1.825,17.93",
    transform: "translate(202 103.909)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M19.295,17.93h5.73a1.825,1.825,0,0,1,1.825,1.825v5.73a1.825,1.825,0,0,1-1.825,1.825h-5.73a1.825,1.825,0,0,1-1.825-1.825v-5.73a1.825,1.825,0,0,1,1.825-1.825",
    transform: "translate(204.834 103.909)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M36.755,17.93h5.73a1.825,1.825,0,0,1,1.825,1.825v5.73a1.825,1.825,0,0,1-1.825,1.825h-5.73a1.825,1.825,0,0,1-1.825-1.825v-5.73a1.825,1.825,0,0,1,1.825-1.825",
    transform: "translate(207.667 103.909)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M22.154,34.96a4.684,4.684,0,1,1-4.684,4.684,4.683,4.683,0,0,1,4.684-4.684",
    transform: "translate(204.834 106.672)",
    fill: "#4154a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M22.154,0A4.684,4.684,0,1,1,17.47,4.684,4.683,4.683,0,0,1,22.154,0",
    transform: "translate(204.834 101)",
    fill: "#4154a1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 49.977,
    height: 50,
    transform: "translate(202 101)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueryIcon);
export default __webpack_public_path__ + "static/media/query-icon.52a7fa40.svg";
export { ForwardRef as ReactComponent };